// store/modules/selectPage.js
import axios from 'axios';

export default {
    namespaced: true,
    state: {
        isInit: false,
        allPages: {},
        pageSelected: [],
        groups: [],
        listRetracted: false,
        storyMode: false,

        // for select page
        formatData: {
            groups: {},
            otherPage: {}
        },
        enableAutoSave: true,
    },
    mutations: {
        updateAllPages(state, newContent) {
            console.log('selectPage/updateAllPages')
            state.allPages = newContent;
        },
        updatePagesSelected(state, { pagesId, saveToLocalStorage }) {
            console.log('selectPage/updatePagesSelected', pagesId, saveToLocalStorage)
            state.pageSelected = pagesId;
            if (saveToLocalStorage || state.enableAutoSave) {
                localStorage.setItem('selectPage/pageSelected', JSON.stringify(state.pageSelected));
            }
        },
        loadPagesSelectedFromLocalStorage(state) {
            console.log('selectPage/loadPagesSelectedFromLocalStorage')
            const stored = localStorage.getItem('selectPage/pageSelected');
            state.pageSelected = stored ? JSON.parse(stored).filter(id => state.allPages[id]) : [];
        },
        savePagesSelectedToLocalStorage(state) {
            console.log('selectPage/savePagesSelectedToLocalStorage')
            try {
                localStorage.setItem('selectPage/pageSelected', JSON.stringify(state.pageSelected));
            } catch (e) {
                console.error('localStorage quota exceeded, could not save page selection:', e);
            }
        },
        updateSelectPageGroups(state, newContent) {
            console.log("selectPage/updateSelectPageGroups")

            state.groups = newContent.reduce((acc, group) => {
                group.pages = group.pages.filter(pageId => state.allPages[pageId]);

                group.pages.forEach(pageId => {
                    if (!state.allPages[pageId].groups) state.allPages[pageId].groups = [];
                    state.allPages[pageId].groups.push(group.id);
                });

                if (group.pages.length) acc[group.id] = group;
                return acc;
            }, {});
        },
        updateSelectPageStoryMode(state, newContent) {
            state.storyMode = newContent;
        },
        updateSelectPageListRetracted(state, newContent) {
            state.listRetracted = newContent;
            localStorage.setItem('selectPage/listRetracted', newContent);
        },
        updateFormatData(state, { groups, otherPage }) { 
            // state.data = { groups, otherPage };
            state.formatData = { groups, otherPage };
        },
        updateIsInit(state, bool) { 
            state.isInit = bool;
        },
        updateEnableAutoSave(state, bool) {
            state.enableAutoSave = bool;
        }
    },
    getters: {
        selectPageAllPages(state) {
            return state.allPages;
        },
        selectPagePageSelected(state) {
            return state.pageSelected;
        },
        selectPageGroups(state) {
            return state.groups;
        },
        selectPageStateListRetracted(state) {
            return state.listRetracted;
        },
        selectPageStoryMode(state) {
            return state.storyMode;
        },
        formatData(state) {
            return state.formatData;
        },
        isInit(state) {
            return state.isInit;
        },
    },

    actions: {
        generateData({ state, commit }) {
            let allPages = state.allPages
            let groups = state.groups.reduce((acc, group) => {
                group.pages = group.pages.filter(pageId => allPages[pageId]);

                group.pages.forEach(pageId => {
                    if (!allPages[pageId].groups) allPages[pageId].groups = [];
                    allPages[pageId].groups.push(group.id);
                });

                if (group.pages.length) acc[group.id] = group;
                return acc;
            }, {});

            let otherPage = Object.values(allPages).reduce((acc, page) => {
                if (!page.groups || !page.groups.length) {
                    acc[page.id] = page;
                }
                return acc;
            }, {});

            commit('updateAllPages', allPages);
            commit('updateFormatData', { groups, otherPage });
        },

        async fetchAllPages({ commit }) {
            console.log('selectPage/fetchAllPages');

            const checkNatif = function (page) {
                switch (page.network) {
                case 'instagram':
                    return page.story_config && page.story_config.created
                case 'facebook':
                    return page.story_config && page.story_config.created
                case 'linkedin':
                    return page.bot_status && page.story_config && page.story_config.created
                case 'tiktok':
                    return page.story_config && page.story_config.created
                case 'twitter':
                    return page.story_config && page.story_config.created
                default:
                    return false
                }
            };

            const buildPagesConvert = (pages, bots) => pages.reduce((pagesObj, page) => {
                pagesObj[page.id] = {
                    ...page,
                    natifMode: checkNatif(page),
                    bots: bots.filter(bot => bot.page.id == page.id)
                };
                return pagesObj;
            }, {});

            const cachedBots = localStorage.getItem('bots');
            const cachedPages = localStorage.getItem('pages');
            if (cachedBots && cachedPages) {
                try {
                    commit('updateAllPages', buildPagesConvert(JSON.parse(cachedPages), JSON.parse(cachedBots)));
                } catch (error) {
                    console.error(error)
                    localStorage.removeItem('bots')
                    localStorage.removeItem('pages')
                }
            }

            try {
                const [botsRes, pagesRes] = await Promise.all([
                    axios.get(`${process.env.VUE_APP_API_HOST}/bots`, {
                        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                    }),
                    axios.get(`${process.env.VUE_APP_API_HOST}/pages`, {
                        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                    }),
                ]);

                const bots = botsRes.data.bots;
                const pages = pagesRes.data.pages;

                try {
                    localStorage.removeItem('bots');
                    localStorage.removeItem('pages');
                    localStorage.setItem('bots', JSON.stringify(bots));
                    localStorage.setItem('pages', JSON.stringify(pages));
                } catch (e) {
                    console.error('localStorage quota exceeded, pages/bots cache not updated:', e);
                }

                commit('updateAllPages', buildPagesConvert(pages, bots));
            } catch (error) {
                console.error('Error fetching all pages for selectPage:', error);
            }
        },

        async fetchGroups({ commit }) {
            console.log('selectPage/fetchGroups');
            try {
                const { data } = await axios.get(`${process.env.VUE_APP_API_HOST}/groups`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                });
                console.log('selectPage/fetchGroups',data.groups);
                commit('updateSelectPageGroups', data.groups);
            } catch (error) {
                console.error('Error fetching groups for selectPage:', error);
            }
        },

        async fetchData({ dispatch }) {
            await dispatch('fetchAllPages');
            await dispatch('fetchGroups');
        },

        async init({ dispatch, commit }) {
            const hasCache = localStorage.getItem('bots') && localStorage.getItem('pages');

            if (hasCache) {
                // Lance le refresh en arrière-plan (le cache est commité de façon synchrone
                // avant le premier await dans fetchAllPages, donc allPages est déjà prêt)
                const refreshPromise = dispatch('fetchAllPages');

                // Les groupes peuvent utiliser les données du cache déjà committées
                await dispatch('fetchGroups');
                commit('loadPagesSelectedFromLocalStorage');
                commit('updateIsInit', true);

                // Une fois le refresh terminé, re-sync les groupes avec les nouvelles pages
                refreshPromise
                    .then(() => dispatch('fetchGroups'))
                    .catch(() => {});
            } else {
                await dispatch('fetchData');
                commit('loadPagesSelectedFromLocalStorage');
                commit('updateIsInit', true);
            }
        },
    },

};
